import { Modal, Select } from "antd";
import { FC, ReactEventHandler, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { ICampusItem } from "../../../../models/campuses.model";
import { RootState } from "../../../../store/rootReducer";
import Button from "../../../Button";
import SelectCampusMultiChoice from "../../../SelectCampusMultiChoice";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  campusCodes: string[];
  setCampusCodes: (campusCodes: string[]) => void;
}

const MultiCampusModal: FC<IProps> = ({
  visible,
  setVisible,
  campusCodes,
  setCampusCodes,
}) => {
  const { t, i18n } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const [campuses, setCampuses] = useState<ICampusItem[]>([]);

  useEffect(() => {
    if (campusData) {
      if (auth.hqYn === 'Y') {
        setCampuses(campusData);
      } else {
        setCampuses(campusData.filter(campus => auth.campus?.includes(campus.campusCode)));
      }
    }
  }, [campusData]);

  return (
    <>
      <Modal
        title={t('statistics.eLearning.title2')}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={400}
        footer={[]}
      >
        <div className="row justify-content-center">
          
            <SelectCampusMultiChoice
              placeholder={t('statistics.eLearning.title2')}
              onChange={setCampusCodes}
              value={campusCodes}
            />
            {/* <Select
              className="w-100"
              placeholder={t('common.button.select')}
              mode="multiple"
              allowClear
              value={campusCodes}
              onChange={e => setCampusCodes(e)}
            >
              {campuses.map((item: ICampusItem) => {
                return (
                  <Select.Option
                    key={item.campusCode}
                    value={item.campusCode}
                  >
                    {i18n.language === 'ko' ? item.campusKorName : item.campusEngName}
                  </Select.Option>
                )
              })}
            </Select> */}
            <div className="comm-btn__area ml-2">
              <Button
                className="btn-basic small pink"
                onClick={() => setVisible(false)}
                text={t('class.class.button3')}
              />
              <Button
                className="btn-basic small gray"
                onClick={() => {
                  setCampusCodes([]);
                  setVisible(false);
                }}
                text={t('statistics.eLearning.Button1')}
              />
            </div>
        </div>
      </Modal>    
    </>
  );
}

export default MultiCampusModal;
